import { ManagedAccount } from '@webdev/user-management';
import React, { FC } from 'react';
import { useGetLicencesByUser } from '../user-management';

export const LicenseCountPerUser: FC<{ userId: ManagedAccount['id'] }> = ({ userId }) => {
  const { allocatedLicenses } = useGetLicencesByUser(userId);
  return <>{allocatedLicenses.length}</>;
};
